import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Paginate } from "../../../components";
import TooltipInfo from "../../../components/TooltipInfo";
import { SiteMeasurementPage } from "./ListSections/SiteMeasurementPage";

const SiteMeasurementsListPage = ({
  env,
  handleEnvChange,
  groups,
  isLoading,
  isError,
  siteMeasurements,
  groupVersions,
  currentGroupVersion,
  pageResetFlag,
  currentTenant,
  ogmpCategories,
  versionsCategories
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;
  const indexOfLastMeasurement = currentPage * itemsPerPage;
  const indexOfFirstMeasurement = indexOfLastMeasurement - itemsPerPage;
  const currentMeasurements = siteMeasurements?.slice(indexOfFirstMeasurement, indexOfLastMeasurement);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = groups?.length ? Math.ceil(groups?.length / itemsPerPage) : 0;

  useEffect(() => {
    setCurrentPage(1);
  }, [pageResetFlag, groups]);

  // accessing localStorage instead of ContextAPI because of how the new client is initialized per environment
  const currentTenantName = localStorage.getItem("selectedTenantName") || null;

  // handle localStorage issues with undefined/null for older browsers
  const isTenantSelected =
    currentTenantName !== null &&
    String(currentTenantName) !== "undefined" &&
    String(currentTenantName) !== "null" &&
    currentTenantName !== "";

  const isGroupVersionSelected =
    currentGroupVersion !== null &&
    String(currentGroupVersion) !== "undefined" &&
    String(currentGroupVersion) !== "null" &&
    currentGroupVersion !== "";

  const tenantHasGroups = isTenantSelected && groups?.length >= 1;
  const tenantHasGroupVersions = isTenantSelected && groupVersions?.length >= 1;

  const tenantHasGroupsAndVersionSelected = tenantHasGroups && isGroupVersionSelected;

  const tenantHasGroupsAndVersions = tenantHasGroups && tenantHasGroupVersions;

  const groupVersionHasSiteMeasurement = siteMeasurements?.length >= 1;

  if (isLoading || isError || !isTenantSelected) {
    return isLoading ? (
      <Container>
        <p>Loading project groups...</p>
      </Container>
    ) : isError ? (
      <Container>
        <p>Error loading project groups.</p>
      </Container>
    ) : (
      <Container>
        <h5>Choose a tenant and an OGMP group version to view site measurements.</h5>
      </Container>
    );
  }

  return !tenantHasGroups ? (
    <TooltipInfo
      message="Chosen Tenant does not have a project group."
      tooltipText="You can start by adding a group under the Project Group tab."
    />
  ) : !tenantHasGroupsAndVersionSelected ? (
    <TooltipInfo message="Choose ogmp group version." tooltipText="You can also add new versions under the Group Versions tab." />
  ) : tenantHasGroupsAndVersions && groupVersionHasSiteMeasurement ? (
    <Container fluid className="mt-2">
      <SiteMeasurementPage
        env={env}
        handleEnvChange={handleEnvChange}
        currentMeasurements={currentMeasurements}
        currentTenant={currentTenant}
        currentTenantName={currentTenantName}
        currentGroupVersion={currentGroupVersion}
        ogmpCategories={ogmpCategories}
        versionsCategories={versionsCategories}
      />
      <Paginate currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
    </Container>
  ) : tenantHasGroupsAndVersions ? (
    <TooltipInfo message="No site measurements found." tooltipText="You can add new site measurements to selected group version." />
  ) : (
    <Container>
      <h5>Choose a tenant and an OGMP group version to view version categories.</h5>
    </Container>
  );
};

export default SiteMeasurementsListPage;
